import { BaseService, Service } from "/@/cool";
@Service("orderTracking")
class OrderTracking extends BaseService {
	InfoOrderTracking(params: any) {
		return this.request({
			url: "/infoOrderTracking",
			method: "POST",
			data: {
				...params
			}
		});
	}

	InfoOrderTrackingByStore(params: any) {
		return this.request({
			url: "/infoOrderTrackingByStore",
			method: "POST",
			data: {
				...params
			}
		});
	}
}
export default OrderTracking;
